import UpdateHistory from "./UpdateHistory";
export default UpdateHistory;
